import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import { TECHNICAL_SANCTION } from "tagTypes";

export const useTechnicalSanctionQuery = (
  applicationRequestDetails,
  query = {}
) =>
  useGetQuery({
    endpoint: `/application/${applicationRequestDetails}/technical-sanction`,
    query,
    tags: [TECHNICAL_SANCTION],
  });

export const useGetSourceOfPowersQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/source-of-power",
    query,
    tags: [TECHNICAL_SANCTION],
  });

export const useGetApprovalTrackingByTechnicalSanctionIdQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/technical-sanction/approval-tracking",
    query,
    tags: [TECHNICAL_SANCTION],
  });

export const useLazyGetBulkTechnicalSanctionQuery = () => {
  const [getTechnicalSanctionData, data] = useLazyGetQuery();
  const getApplicationsData = async (query = {}) =>
    await getTechnicalSanctionData(
      {
        endpoint: "power/application/pending-technical-sanction-approval",
        query,
        tags: [TECHNICAL_SANCTION],
      },
      true
    ).unwrap();
  return [getApplicationsData, data];
};

export const useLazyGetBulkOtherUtilityTechnicalSanctionQuery = () => {
  const [getTechnicalSanctionData, data] = useLazyGetQuery();
  const getApplicationsData = async (query = {}) =>
    await getTechnicalSanctionData(
      {
        endpoint:
          "/other-utility-application/pending-technical-sanction-approval",
        query,
        tags: [TECHNICAL_SANCTION],
      },
      true
    ).unwrap();
  return [getApplicationsData, data];
};

export const useLazyGetTechnicalSanctionDataByIdQuery = () => {
  const [getTechnicalSanctionData, data] = useLazyGetQuery();
  const getTechnicalSanction = async (technicalSanctionId, query = {}) =>
    await getTechnicalSanctionData(
      {
        endpoint: `/technical-sanction/${technicalSanctionId}`,
        query,
        tags: [TECHNICAL_SANCTION],
      },
      true
    ).unwrap();
  return [getTechnicalSanction, data];
};

export const useLazyGetSourceOfPowerQuery = () => {
  const [getSourceOfPowers, data] = useLazyGetQuery();
  const getSourceOfPowerOptions = async (query = {}) =>
    await getSourceOfPowers(
      {
        endpoint: "/source-of-power",
        query,
        tags: [TECHNICAL_SANCTION],
      },
      true
    ).unwrap();
  return [getSourceOfPowerOptions, data];
};

export const useLazyTechnicalSanctionQuery = () => {
  const [getTechnicalSanction, data] = useLazyGetQuery();
  const fetchTechnicalSanctionData = async (applicationId, query = {}) =>
    await getTechnicalSanction(
      {
        endpoint: `/application/${applicationId}/technical-sanction`,
        query,
        tags: [TECHNICAL_SANCTION],
      },
      true
    ).unwrap();
  return [fetchTechnicalSanctionData, data];
};

export const usePostTechnicalSanctionMutation = () => {
  const [technicalSanction, data] = usePostMutation();
  const addTechnicalSanction = async (payload, query = {}) =>
    await technicalSanction({
      endpoint: "/technical-sanction",
      query,
      payload: payload || {},
      toastMessage: "Technical Sanction added successfully",
      tags: [TECHNICAL_SANCTION],
    }).unwrap();
  return [addTechnicalSanction, data];
};

export const usePutTechnicalSanctionDocumentApproveMutation = () => {
  const [updateTechnicalSanction, data] = usePutMutation();
  const updateTechnicalSanctionData = async (payload, query = {}) =>
    await updateTechnicalSanction({
      endpoint: "/technical-sanction/approve-technical-sanction",
      query,
      payload: payload || {},
      toastMessage: "Technical Sanction document status updated successfully",
      tags: [TECHNICAL_SANCTION],
    }).unwrap();
  return [updateTechnicalSanctionData, data];
};

export const usePutBulkTechnicalSanctionDocumentApproveMutation = () => {
  const [updateTechnicalSanction, data] = usePutMutation();
  const updateTechnicalSanctionData = async (payload, query = {}) =>
    await updateTechnicalSanction({
      endpoint: "/technical-sanction/bulk-approve-technical-sanction",
      query,
      payload: payload || {},
      toastMessage: "Technical Sanction document status updated successfully",
      tags: [TECHNICAL_SANCTION],
    }).unwrap();
  return [updateTechnicalSanctionData, data];
};

export const usePutRevokeTechnicalSanctionMutation = () => {
  const [revokeApplication, data] = usePutMutation();
  const revokeTechnicalSanctionApplication = async (applicationId) =>
    await revokeApplication({
      endpoint: `/application/${applicationId}/application-revoke`,
      toastMessage: "Application revoked successfully",
      tags: [TECHNICAL_SANCTION],
    }).unwrap();
  return [revokeTechnicalSanctionApplication, data];
};
